var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"white",attrs:{"label":"Plan","items":_vm.data,"item-text":"name","item-value":"key","loading":_vm.api.isLoading,"placeholder":"Plan"},model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}})}
var staticRenderFns = []

export { render, staticRenderFns }